import React, { createContext, useContext } from 'react';

export const FieldMappingContext = createContext({
  formType: '',
  parsedFields: 0,
  onBobAIHoverStart: null,
  onBobAIHoverEnd: null,
});

export const useFieldMappingContext = () => useContext(FieldMappingContext);

export const FieldMappingProvider = ({formType, parsedFields, onBobAIHoverStart, onBobAIHoverEnd, children,
}) => (
  <FieldMappingContext.Provider value={{ formType, parsedFields, onBobAIHoverStart, onBobAIHoverEnd }}>{children}</FieldMappingContext.Provider>
);
